<template>
    <div class="civii-carousel-container">
        <div class="carousel-slide">
            <div class="carousel-slide-title">{{slides[currentSlideIndex].title}}</div>
            <hr v-if="isString(slides[currentSlideIndex].title)" class="carousel-line">
            <div class="carousel-slide-content">
                <content-render :content="slides[currentSlideIndex].content"/>
            </div>
            <action-buttons v-if="hasButtons(slides[currentSlideIndex])" :buttons="slides[currentSlideIndex].buttons"/>
            
        </div>
        <div @click="prev" class="carousel-nav-left" v-show="!isFirstSlide()">
            <i class="civii-icon-arrow-left"></i>
        </div>
        <div @click="next" class="carousel-nav-right" v-show="!isLastSlide()">
            <i class="civii-icon-arrow-right"></i>
        </div>
    </div>
</template>

<script>
import ContentRender from '../../widgets/ContentRender/ContentRender.js'
import ActionButtons from '../../widgets/ActionButtons/ActionButtons.vue'

export default {
    components: {
        'action-buttons': ActionButtons,
        'content-render': ContentRender
    },
    props: {
        slides: Array
    },
    data () {
        return {
            currentSlideIndex: 0
        }
    },
    methods: {
        isString: function( value ){
            return typeof value === 'string' || value instanceof String;
        },
        hasButtons: function( slide ){
            return slide.hasOwnProperty('buttons') && slide.buttons.length > 0;
        },
        isFirstSlide: function(){
            return this.currentSlideIndex === 0;
        },
        isLastSlide: function(){
            return this.currentSlideIndex === (this.slides.length - 1);
        },
        next () {
            if( this.currentSlideIndex < (this.slides.length - 1)) this.currentSlideIndex++;
        },
        prev () {
            if( this.currentSlideIndex > 0) this.currentSlideIndex--;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/answers/Carousel/Carousel.vue